import { computed, onMounted, ref, useContext } from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import { getCurrencyCode } from '~/helpers/utils';

export default function usePaypalMessaging() {
  const vsfContext = useVSFContext();
  const context = useContext() as any;
  const $config = context.$config || {};
  const $paypalSdk = (context.$paypalSdk as any) || null;

  const isPaypalSdkReady = ref(false);
  const isPaypalMessagingEnabled = computed(() =>
    [21, 57].includes(vsfContext.$novulo?.config?.state?.getWt())
  );

  onMounted(() => {
    if (!isPaypalMessagingEnabled.value || !$paypalSdk || !$config.paypalClientId)
      return;

    const currency = getCurrencyCode({ vsfContext });
    $paypalSdk({
      'client-id': $config.paypalClientId,
      components: 'messages,buttons',
      currency,
      dataNamespace: 'PayPalSDK'
    })
      .then(() => {
        isPaypalSdkReady.value = true;
      })
      .catch(() => {});
  });

  return {
    isPaypalMessagingEnabled,
    isPaypalSdkReady
  };
}
